import {CourseOption, CourseRepository} from "@app/@core/repositories/course.repository";
import {PackageInfoOption, PackageInfoRepository} from "@app/@core/repositories/package-info.repository";
import {Injectable} from "@angular/core";
import {Repository} from "@app/@core/repositories/repository";
import {createState, select, Store, withProps} from "@ngneat/elf";
import {
    deleteAllEntities, deleteEntities,
    getEntities,
    selectAll,
    setEntities,
    upsertEntities,
    withEntities
} from "@ngneat/elf-entities";
import {CourseState} from "@app/@core/services/course.service";
import {PackageModel} from "@app/@core/domain/package.model";
import {groupBy} from "lodash-es";
import {SelectItemGroup} from "primeng/api";
import orderBy from "lodash-es/orderBy";
import {environment} from "@env/environment";
import {localStorageStrategy, persistState} from "@ngneat/elf-persist-state";
import {Observable} from "rxjs";
import {map, tap} from "rxjs/operators";
import {PackageInfoModel} from "@app/models/package-info";
import {LeisureShopRepository} from "@app/@core/repositories/leisure-shop.repository";
import {formly, formlyRow, formlyRow2, options} from "@shared/helper/formly-helpers";
import PackageInfoStatus = PackageModel.PackageInfoStatus;


export interface PackageInfoState {
    options?: PackageInfoOption[];
}

const {state, config} = createState(
    withEntities<PackageModel.PackageInfo>(),
    withProps<PackageInfoState>({
        options: []
    })
);
const store = new Store({name: 'packageStore', state, config});

const getState = () => store.getValue();

const updateState = (newState: Partial<PackageInfoState>) => {
    store.update(s => ({...s, ...newState}));
};

@Injectable({
    providedIn: 'root'
})
export class PackageInfoService {

    groupedOptions$ = store.pipe(select((({options}) => {
        const groupByStatus = groupBy(options, 'status');
        const sig: SelectItemGroup[] = [
            {label: 'ACTIVE', items: orderBy(groupByStatus.ACTIVE, 'name')},
            {label: 'INACTIVE', items: orderBy(groupByStatus.INACTIVE, 'name')},
        ];
        return sig;

    })));
    selectShopOptions$ = store.pipe(
        select(({options}) => {
            return options.map(option => ({
                label: option.label,
                value: option.value
            }));
        })
    );
    groupedOptionsNotRequire$ = store.pipe(select((({options}) => {
        const groupByStatus = groupBy(options, 'status');
        const sig: SelectItemGroup[] = [
            {
                label: 'ACTIVE',
                items: [{label: '- Not Select -', value: undefined}, ...orderBy(groupByStatus.ACTIVE, 'name')]
            },

            {label: 'INACTIVE', items: orderBy(groupByStatus.INACTIVE, 'name')},
        ];
        return sig;
    })));
    package$ = store.pipe(selectAll());

    constructor(private repository: PackageInfoRepository,
                private leisureShopRepository: LeisureShopRepository,
                private packageInfoRepository: PackageInfoRepository) {
        if (environment.cache?.shop) {
            persistState(store, {
                key: 'package',
                storage: localStorageStrategy,
            });
        }
    }


    getName(packageId: string) {
        const p = getState().options.find(c => c.value === packageId);
        return p
            ? p.status === 'ACTIVE' ? p.label : `${p.label}[${p.status}]`
            : packageId;
    }

    hasLoaded() {
        return getState().options.length > 0;
    }

    fetchAllName(): Observable<PackageInfoOption[]> {
        return this.packageInfoRepository.getPackageAll().pipe(
            map((packages) =>
                packages.map(pkg => ({
                    value: pkg.id,
                    label: pkg.packageName,
                    status: pkg.active ? 'ACTIVE' : 'INACTIVE' as PackageInfoStatus
                }))
            ),
            tap((options) => updateState({options}))
        );
    }


    getAll(force = false) {
        if (force || store.query(getEntities()).length === 0) {
            this.repository.getPackageAll().subscribe(packages => {
                store.update(deleteAllEntities());
                // store.update(setEntities(courses));
            });
        }
    }

    updatePackage(packages: PackageInfoModel.PackageInfo) {
        store.update(upsertEntities(packages));
    }

    delete(id: string) {
        store.update(deleteEntities(id));
    }

}
